import { Feature, Map, Overlay, View } from 'ol';
import { Control } from 'ol/control';
import { Geometry } from 'ol/geom';
import { Interaction } from 'ol/interaction';
import BaseLayer from 'ol/layer/Base';
import RenderFeature from 'ol/render/Feature';
import { Style } from 'ol/style';
import { BehaviorSubject, Observable } from 'rxjs';

export abstract class OpenLayersModel {
  private _styles: {
    [key: string]: Style;
  };
  private _dynamicStyles: {
    [key: string]: (feature: RenderFeature | Feature<Geometry>) => Style | Style[];
  };
  private _layers: BehaviorSubject<BaseLayer[]> = new BehaviorSubject<BaseLayer[]>([]);
  public layers$: Observable<BaseLayer[]> = this._layers.asObservable();
  private _controls: BehaviorSubject<Control[]> = new BehaviorSubject<Control[]>([]);
  public controls$: Observable<Control[]> = this._controls.asObservable();
  private _interactions: BehaviorSubject<Interaction[]> = new BehaviorSubject<Interaction[]>([]);
  public interactions$: Observable<Interaction[]> = this._interactions.asObservable();
  private _overlays: BehaviorSubject<Overlay[]> = new BehaviorSubject<Overlay[]>([]);
  public overlays: Observable<Overlay[]> = this._overlays.asObservable();

  protected _map: Map;

  get map(): Map {
    return this._map;
  }

  private _view: BehaviorSubject<View> = new BehaviorSubject<View>(null);

  public view$: Observable<View> = this._view.asObservable();

  get view(): View {
    return this._view.getValue();
  }

  protected initialize(): void {
    this._styles = this.initStyles();
    this._dynamicStyles = this.initDynamicStyles();
    this._layers.next(this.initLayers());
    this._view.next(this.initView());
    this._interactions.next(this.initInteractions());
    this._controls.next(this.initControls());
    this._overlays.next(this.initOverlays());
  }

  protected initStyles(): { [key: string]: Style } {
    return null;
  }

  protected initDynamicStyles(): { [key: string]: (feature: RenderFeature | Feature<Geometry>) => Style | Style[] } {
    return null;
  }

  protected initLayers(): BaseLayer[] {
    return [];
  }

  protected initView(): View {
    return null;
  }

  protected initInteractions(): Interaction[] {
    return [];
  }

  protected initControls(): Control[] {
    return [];
  }

  protected initOverlays(): Overlay[] {
    return [];
  }

  protected setMap(map: Map): void {
    this._map = map;
  }

  protected getStyle(key: string): Style {
    if (!(key in this._styles)) return null;

    return this._styles[key];
  }

  protected getDynamicStyle(key: string, feature: RenderFeature | Feature<Geometry>): Style | Style[] {
    if (!(key in this._dynamicStyles)) return null;

    return this._dynamicStyles[key](feature);
  }
}
